
webpack.register(
    'modules/tee-times/tee-times',
    function() {
        return import('modules/tee-times/tee-times');
    },
    true
);